export enum FeatureProperty {
  CompanyId = 'companyId',
  DemioId = 'demioId',
}
